import BlockContainerAction from '../../actions/blockContainerAction';
import editorAction from '../../actions/editorAction';
import { useTreeStateContext } from '../../contexts/TreeContext';
import { useEditorStateContext } from '../../contexts/EditorContext';
import offsetPanzoneContainer from '../../data/offsetPanzoneContainer';
import useBlockFilter from './useBlockFilter';
import useBlock from './useBlock';
import useCtrlKey from '../useCtrlKey';
import useShiftKey from '../useShiftKey';

function useBlockSelection() {

    const { setZoneSelectBlocks } = editorAction()
    const { addSelectedBlock : addSelectedBlockAction, updateMouseAndBlockClicked, setSelectedBlocks, deleteSelectedBlock, deleteAllSelectedBlock } = BlockContainerAction(); 

    const { zoneSelectBlocks } = useTreeStateContext();
    const { ctrlKey } = useCtrlKey();
    const { shiftKey } = useShiftKey();

    const { getBlockInformation } = useBlock();

    const { pathTmp, blocksSelected, blockIdClicked } = useEditorStateContext();
    const { filterBlocksSelected } = useBlockFilter();

    const offset = offsetPanzoneContainer;

    const selectBlock = (e, id) => {
        updateMouseAndBlockClicked(e.clientX, e.clientY, id);
        shiftKey ? selectBlockIfShiftKey(e, id) : selectBlockIfNotShiftKey(e, id);
    }

    const selectBlockIfShiftKey = (e, id) => {
        if(e.target.id != id || pathTmp || ctrlKey == false) return;
        blocksSelected.find(block => block.id == id) ? deleteSelectedBlockById(id) : addSelectedBlockById(id);
    }

    const selectBlockIfNotShiftKey = (e, id) => {
        if(e.target.id != id || pathTmp || blocksSelected.find(block => block.id == id)) return;
        deleteAllSelectedBlock();
        const block = document.querySelector('.block.selected');
        if(block) block.classList.remove('selected');
        addSelectedBlockById(id);
    }

    const dropBlock = (e, id) => {
        updateMouseAndBlockClicked(0, 0);
    }

    const deleteSelectedBlockById = (id) => {
        document.getElementById(id)?.classList.remove("selected");
        deleteSelectedBlock(id);
    }

    const addSelectedBlockById = (id) => {
        document.getElementById(id).classList.add("selected") 
        const {block, paths_out, paths_in} = getBlockInformation(id);
        addSelectedBlockAction({block , paths_out , paths_in, id})
    }

    const makeZoneSelection = (x, y) => {
        let selection = document.getElementById('zone_blocks_selection');
        setZoneSelectBlocks( x, y);
        selection.style.left = x + offset.x + "px";
        selection.style.top = y + offset.y + "px";
        selection.style.opacity = 1;
    }

    const updateZoneSelection = (x, y, position, startPosition = 0) => {
        let selection = document.getElementById('zone_blocks_selection');
        //x = (x + position.x) / position.scale;
        //y = (y + position.y) / position.scale;
        let width = Math.abs(x - zoneSelectBlocks.x);
        let height = Math.abs(y - zoneSelectBlocks.y);
        
        let areaSelected = zoneSelectBlocks

        if (startPosition != 0 && zoneSelectBlocks.x == 0 && zoneSelectBlocks.y == 0){
            areaSelected = startPosition;
        }
        
        selection.style.width = width + "px";
        selection.style.height = height + "px";
        selection.style.left = (x < areaSelected.x ? x : areaSelected.x) + offset.x + "px";
        selection.style.top = (y < areaSelected.y ? y : areaSelected.y) + offset.y + "px";
        selection.style.opacity = 1;

        const blocksFind = filterBlocksSelected(position,areaSelected, x, y , width, height);
        const newBlocksSelected = [];
        for(var i = 0; i < blocksFind.length; i++) {
            let id = blocksFind[i].object_id
            const {block, paths_out, paths_in} = getBlockInformation(id);
            document.getElementById(id).classList.add("selected"); 
            newBlocksSelected.push({block , paths_out , paths_in, id});
        }
        let blocksToUnselect = blocksSelected.filter(a => !newBlocksSelected.some(b => b.id == a.id));
        blocksToUnselect.map(block => document.getElementById(block.id).classList.remove("selected"))
        //blocksToUnselect.map(block => document.getElementById(block.id).classList.remove("selected"))
        setSelectedBlocks(newBlocksSelected);
        /*
        let blocksToSelect = blocksComparaison(blocksFind, blocksSelected);
        blocksToSelect.map(block => addSelectedBlockById(block.object_id));
        let blocksTest = blocksComparaison(blocksToSelect, blocksSelected);
        */
        //let blocksToUnselect = blockNotAlreadySelected(idOfBlocksFind);
        return newBlocksSelected
    }

    const resetZoneSelection = () => {
        let selection = document.getElementById('zone_blocks_selection');
        setZoneSelectBlocks(0, 0);
        selection.style.left = 0 + "px";
        selection.style.top = 0 + "px";
        selection.style.width = 0 + "px";
        selection.style.height = 0 + "px";
        selection.style.opacity = 0;
    }

    const isBlockSelected = (id) => {
        for(let index in blocksSelected) {
            if(blocksSelected[index].id == id) return true;
        }

        return false;
    }

    const deselectAllBlocks = (blocks = []) => { 
        blocks = blocksSelected.length == 0 && blocks.length > 0? blocks : [] ;  
        for (let i = 0; i < blocks.length; i++) {
            deleteSelectedBlockById(blocks[i].id)
        }
    }
    /*
    const enableMultipleSelectionBlock = (e) => {
        if (e.ctrlKey == false || ctrlKey == true) return;
        setCtrlKey(true)
    }

    const disableMultipleSelectionBlock = (e) => {
        if (ctrlKey == false) return;
        setCtrlKey(false)
    }*/

    return { 
        selectBlock, 
        dropBlock, 
        resetZoneSelection,
        makeZoneSelection, 
        updateZoneSelection, 
        blockIdClicked,
        blocksSelected,
        zoneSelectBlocks,
        isBlockSelected,
        shiftKey,
        deselectAllBlocks
    }
}

export default useBlockSelection;